import React from 'react';
import ServiceOffline from './ServiceOffline';

const App = () => {
  return <ServiceOffline />;
};

export default App;
